import { TOKEN_UNAVAILABLE_MESSAGE } from '~/helpers/axiosAuth'

export const getAxiosErrorMessage = (error) => {
  // トークンが一時的に取れないまま送って 401 になったリクエスト(plugins/axios.js)は通信失敗の文言にする
  if (error && error.isTokenUnavailable) {
    return TOKEN_UNAVAILABLE_MESSAGE
  }
  // axiosのエラーレスポンスからメッセージを取得
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.error
  ) {
    return error.response.data.error
  }

  return null
}
